import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  itemSaved = new EventEmitter<boolean>();
  itemSavedOrder = new EventEmitter<boolean>();
  itemCreated = new EventEmitter<boolean>();

  constructor() { }
}
